/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { List, ListItem, ListSubheader, Button, TextField, Grid } from "@material-ui/core";
import { InputTooltip } from "../../../../components";
import { AGENT_STATUS_ALERT_TOOLTIPS } from "../../../../utility/toolTipMessages";
import { AGENT_STATUS_ALERTS } from "../../../../utility/constants";
import { ActionButtons } from "../../../../components/Common";

export const AlertsList = ({ alerts, addAlertHandler, removeAlertHandler, updateTime, updateMessage, formEdited }) => {
	return (
		<div>
			<List
				component="nav"
				subheader={
					<ListSubheader disableSticky component="div" className="p-0">
						<div className="d-flex justify-content-between align-items-center">
							<span>Alerts</span>
							<Button variant="outlined" size="small" onClick={addAlertHandler}>
								Add alert
							</Button>
						</div>
					</ListSubheader>
				}
			>
				{alerts?.length ? (
					alerts.map((x) => (
						<AlertItem
							key={x.id}
							formEdited={formEdited}
							alert={x}
							updateTime={updateTime}
							updateMessage={updateMessage}
							removeAlertHandler={removeAlertHandler}
						/>
					))
				) : (
					<ListItem>
						<span className="text-danger font-italic">At least one alert is required.</span>
					</ListItem>
				)}
			</List>
		</div>
	);
};

const AlertItem = ({ alertsCount, alert, updateTime, updateMessage, removeAlertHandler }) => {
	return (
		<ListItem className="d-flex p-0">
			<Grid container justifyContent="space-between" alignItems="flex-start" wrap="wrap" spacing={2} className="mb-2">
				<Grid item className="col-6 col-lg-3 order-1">
					<TextField
						label="Time (mins)"
						type="number"
						className="w-100"
						required
						helperText={!alert?.time ? "Time is required." : alert?.error}
						title={alert?.time ? "" : "Please provide time (in minutes)."}
						onChange={(e) => updateTime(e, alert?.id)}
						value={alert?.time ? alert?.time : ""}
						error={!alert?.time || alert?.error?.length > 0}
						inputProps={{ min: 0 }}
						InputProps={{
							startAdornment: <InputTooltip title={AGENT_STATUS_ALERT_TOOLTIPS.ALERT_TIMEOUT_TOOLTIP} />,
						}}
					/>
				</Grid>
				<Grid item className="col-12 col-lg-7 order-lg-2 order-3">
					<TextField
						label="Message"
						inputProps={{
							maxLength: AGENT_STATUS_ALERTS.ALERT_MESSAGE_LENGTH,
						}}
						required
						InputProps={{
							startAdornment: <InputTooltip title={AGENT_STATUS_ALERT_TOOLTIPS.ALERT_MESSAGE_TOOLTIP} />,
						}}
						error={!alert?.message}
						className="w-100"
						multiline
						maxRows={2}
						title={alert?.message ? "" : "Please provide a message."}
						onChange={(e) => updateMessage(e, alert?.id)}
						helperText={`${alert?.message.length}/${AGENT_STATUS_ALERTS.ALERT_MESSAGE_LENGTH} ${
							!alert?.message ? "- Message is required" : ""
						}`}
						value={alert?.message}
					/>
				</Grid>
				<Grid item className="col-2 align-self-center order-2 order-lg-3">
					<ActionButtons
						className="float-right"
						showRemove
						onRemove={() => removeAlertHandler(alert?.id)}
						disableRemove={alertsCount > 2}
					/>
				</Grid>
			</Grid>
		</ListItem>
	);
};
